module.exports = __webpack_public_path__ + "static/q20-647ce64bbbb8e580cfc29fd7e7279008.png";